<div
  class="container mx-auto px-4 max-w-xl md:max-w-2xl min-h-[90vh] pt-24 flex items-start justify-center"
>
  <div class="w-full">
    <div>
      <h3 class="text-2xl font-semibold">Profile</h3>
      <h6 class="text-base-content/70">Update your profile</h6>
    </div>

    <div class="daisy-card daisy-card-bordered bg-base-100 mt-3 shadow-sm">
      <div class="daisy-card-body">
        @if (error) {
          <div class="daisy-alert daisy-alert-error" role="alert">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span class="ml-2">{{ error }}</span>
          </div>
        }

        <form [formGroup]="profileUpdateForm" class="grid gap-4">
          <div class="input-block">
            <fieldset class="daisy-fieldset">
              <legend class="daisy-fieldset-legend">First Name</legend>
              <input
                formControlName="firstName"
                type="text"
                placeholder="First Name"
                class="daisy-input daisy-input-bordered w-full"
              />
            </fieldset>
            @if (
              firstName?.invalid && (firstName?.dirty || firstName?.touched)
            ) {
              <div aria-live="polite">
                @if (firstName?.hasError('required')) {
                  <p class="text-error">First Name is required.</p>
                }
              </div>
            }
          </div>

          <div class="input-block">
            <fieldset class="daisy-fieldset">
              <legend class="daisy-fieldset-legend">Last Name</legend>
              <input
                formControlName="lastName"
                type="text"
                placeholder="Last Name"
                class="daisy-input daisy-input-bordered w-full"
              />
            </fieldset>
            @if (lastName?.invalid && (lastName?.dirty || lastName?.touched)) {
              <div aria-live="polite">
                @if (lastName?.hasError('required')) {
                  <p class="text-error">Last Name is required.</p>
                }
              </div>
            }
          </div>

          <div class="input-block">
            <fieldset class="daisy-fieldset">
              <legend class="daisy-fieldset-legend">Bio</legend>
              <black-rich-text-editor
                formControlName="bio"
                placeholder="Tell us a little bit about yourself..."
                theme="snow"
                minHeight="200px"
              ></black-rich-text-editor>
            </fieldset>
          </div>

          <div class="input-block">
            <fieldset class="daisy-fieldset">
              <legend class="daisy-fieldset-legend">User Avatar</legend>
              <div class="avatar-wrapper">
                <div class="avatar">
                  <black-user-avatar
                    (uploadSuccess)="avatarUploadSuccessHandler($event)"
                  ></black-user-avatar>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mt-3 flex flex-col gap-2">
            <button
              type="button"
              class="daisy-btn daisy-btn-primary daisy-btn-block"
              (click)="updateProfile()"
            >
              Update Profile
            </button>
            <button
              type="button"
              class="daisy-btn daisy-btn-outline daisy-btn-block"
              (click)="skipProfileUpdate()"
            >
              Skip for now
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
